import { formatUnits } from '@shared/lib/format';
import type { CardGasRequirement } from './card-funding-signer';

export type CardGasState =
  | { readonly kind: 'unknown' }
  | { readonly kind: 'covered' }
  | { readonly kind: 'empty' }
  | { readonly kind: 'short'; readonly required: string; readonly available: string };

export function cardGasState(
  requirement: CardGasRequirement | null,
  availableRaw: bigint | null,
): CardGasState {
  if (requirement?.requiredRaw === 0n) return { kind: 'covered' };
  if (availableRaw === 0n) return requirement ? shortfall(requirement, 0n) : { kind: 'empty' };
  if (!requirement || availableRaw === null) return { kind: 'unknown' };
  if (availableRaw >= requirement.requiredRaw) return { kind: 'covered' };
  return shortfall(requirement, availableRaw);
}

function shortfall(requirement: CardGasRequirement, availableRaw: bigint): CardGasState {
  return {
    kind: 'short',
    required: formatUnits(requirement.requiredRaw, requirement.decimals),
    available: formatUnits(availableRaw, requirement.decimals),
  };
}
